module.exports = __webpack_public_path__ + "assets/img/wine-orange.9ae6acbc.svg";